import withReadyOnlyAbility from 'shared/components/formFields/ReadOnlyAbilityWrapper';
import { withFormMeta } from 'shared/components/FormMeta';
import withReduxForm from 'shared/components/formFields/ReduxForm/ReduxFormFieldWrapper';
import AddressInput from './AddressInput';
import { getDisplayAddress } from '../../../../../utils/address';

export default withReduxForm(() => ({
  readOnlyFormatter: getDisplayAddress,
}))(withFormMeta(withReadyOnlyAbility(AddressInput)));
